module.exports = __webpack_public_path__ + "static/media/rhsc_cga_multi_img_background.20f2411a.png";